import { useState, useEffect } from "react";

/**
 * useAuth Hook
 * Centralizes access to localStorage("userLoggedIn")
 */
const useAuth = () => {
    const [user, setUser] = useState(null);

    // Helper to safely parse user data
    const getUserFromStorage = () => {
        try {
            const storedData = localStorage.getItem("userLoggedIn");
            return storedData ? JSON.parse(storedData) : null;
        } catch (error) {
            console.error("Error parsing user data from localStorage:", error);
            return null;
        }
    };

    // We use a simple read on every call to mimic existing behavior of components
    // reading directly from localStorage during render.
    // Using state/effect might cause flickering if we don't initialize synchronously,
    // but standard hooks usually initialize state.
    // HOWEVER, many existing components do `const user = JSON.parse(...)` at the top level.
    // If we change this to `useEffect`, we might break things that expect data immediately.
    // So we will initialize state directly from storage.

    const currentUser = getUserFromStorage();
    const roleString = currentUser?.role || null;
    const isAdmin = roleString?.toLowerCase() === 'admin';

    return {
        user: currentUser,
        token: currentUser?.token,
        userId: currentUser?.user_id,
        roleId: currentUser?.role_id,
        organisationId: currentUser?.organisation_id,
        customerId: currentUser?.customer_id,
        supplierId: isAdmin ? null : (currentUser?.supplierId || currentUser?.user_id), // Use TEP ID for suppliers, fallback to USerID
        role: roleString,
        isAuthenticated: !!currentUser,
    };
};

export default useAuth;
